module.exports = __webpack_public_path__ + "files/dd34b7fb29ba8ef5de724b7b79fb7e6e.svg";